
import React from 'react';
import PropTypes from 'prop-types';
import useIconStyles from '../useIconStyles';

const CloseIcon = (props) => {
  const { color, rotation, className, size } = props;
  const classes = useIconStyles({ color, rotation });

  return (
    <svg
      className={[
        classes.wrapper,
        className,
        size && classes[size],
      ].filter(Boolean).join(' ')}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className={classes.stroke}
        x="1.04004"
        y="5.44"
        width="8.2"
        height="8.2"
      />
      <path
        className={classes.stroke}
        d="M4.12012 4.21334V1.04001H13.6401V10.56H10.4668"
      />
    </svg>
  );
};

CloseIcon.defaultProps = {
  color: undefined,
  rotation: undefined,
  className: undefined,
  size: undefined,
};

CloseIcon.propTypes = {
  color: PropTypes.string,
  rotation: PropTypes.number,
  className: PropTypes.string,
  size: PropTypes.string,
};

export default CloseIcon;
